export default __webpack_public_path__ + "static/media/MercaZTumaco.67592ef2.geojson";